import React, {Component} from 'react';
import PropTypes from 'prop-types';
import shouldUpdate from 'recompose/shouldUpdate';
import LocationAuditStaticTable from '../components/LocationAuditStaticTable';
import {TableBody, TableRow, TableRowColumn} from 'material-ui/Table';
import DatagridCell from 'admin-on-rest/lib/mui/list/DatagridCell';

/**
 * The DatagridBodyLocationAudit component duplicates the AOR DatagridBody, which renders a list of records as a table.
 * It handles the list, includes rows for child data, and listens for toggle events.
 */
class DatagridBodyLocationAudit extends Component {
    constructor(props) {
        super(props);

        this.handleLocationAuditToggle = this.handleLocationAuditToggle.bind(this);

        this.state = {
            currentToggle: {},
            idsList: []
        };
    }

    componentWillMount() {
        // Set an eventemitter listener to handle Location Audit row toggling
        const eventEmitter = this.props.eventEmitter;
        eventEmitter.on(this.props.toggleEventName, (id) => {
            this.handleLocationAuditToggle(id);
        });
    }

    componentWillReceiveProps(nextProps) {
        // Check for update to current toggle object (if state/props is used)
        if (
            nextProps.currentToggle !== this.props.currentToggle ||
            nextProps.idsList !== this.props.idsList
        ) {
            this.setState({
                currentToggle: nextProps.currentToggle,
                idsList: nextProps.idsList
            });
        }
    }

    handleLocationAuditToggle = (id) => {
        let idsList = this.state.idsList;
        let idx = idsList.findIndex(p => p.id === id);
        if (idx >= 0) {
            // Switch visibility and update viewed status
            idsList[idx].expanded = !idsList[idx].expanded;
            if (!idsList[idx].viewed) {
                idsList[idx].viewed = true;
            }
            this.setState({
                idsList: idsList
            });
        }
    };

    getBasePathUpOne = (basePath) => {
        return basePath
            .split('/')
            .slice(0, -1)
            .join('/');
    };

    render() {
        const {
            resource,
            children,
            columns,
            currentToggle,
            eventEmitter,
            idsList,
            data,
            basePath,
            isLoading,
            styles,
            options,
            rowOptions,
            toggleEventName,
            ...rest
        } = this.props;

        const rowList = this.state.idsList;

        const tableStyles = {
            closed: {
                display: 'none',
                height: 0,
                fontSize: 0,
                lineHeight: 0,
                padding: 0,
                borderBottom: 'none',
                overflow: 'hidden',
            },
            open: {
                display: 'table-cell',
                padding: 0,
                height: 'auto',
                minHeight: 48,
                fontSize: 13,
                borderBottom: 'none',
            },
            noBorder: {
                borderBottom: 'none',
            },
        };

        return (
            <TableBody
                displayRowCheckbox={false}
                className="datagrid-body"
                {...rest}
                {...options}
            >
                {idsList.map((item, rowIndex) => {
                    return (
                        [
                            <TableRow
                                style={styles.auditRow}
                                key={'location-audit-' + item.id + rowIndex}
                                selectable={false}
                                className={`datagrid-row-${item.id}`}
                                {...rowOptions}
                            >
                                {React.Children.map(
                                    children,
                                    (field, index) =>
                                        field ? (
                                            <DatagridCell
                                                key={`${item.id}-${(field.props.source + '-' + index) || index}`}
                                                className={`column-${field.props.source}`}
                                                record={data[item.id]}
                                                defaultStyle={
                                                    index === 0 ? (
                                                        styles.cell['td:first-child']
                                                    ) : (
                                                        styles.cell.td
                                                    )
                                                }
                                                style={styles.auditCell}
                                                {...{field, basePath, resource}}
                                            />
                                        ) : null
                                )}
                            </TableRow>,
                            <TableRow
                                key={'location-audits-' + item.id + rowIndex}
                                className={`datagrid-row-detail-${item.id}-${rowIndex}`}
                                style={{...styles.auditResultRow, ...tableStyles.noBorder}}
                                {...rowOptions}
                            >
                                {rowList && rowList.length && rowList[rowIndex].viewed &&
                                <TableRowColumn
                                    key={`location-audit-cell-${item.id}`}
                                    id={`location-audit-cell-${item.id}-${rowIndex}`}
                                    className={`location-audit-cell${(rowList[rowIndex].expanded) ? ' open' : ' closed'}`}
                                    colSpan={columns}
                                    style={(rowList[rowIndex].expanded) ? tableStyles.open : tableStyles.closed}
                                >
                                    <LocationAuditStaticTable
                                        locationId={item.id.toString()}
                                        locationAuditPath="/LocationAudits"
                                        viewType="list"
                                        showView={true}
                                        style={(rowList[rowIndex].expanded) ? tableStyles.open : tableStyles.closed}
                                    />
                                </TableRowColumn>
                                }
                            </TableRow>
                        ]
                    )
                })}
            </TableBody>
        )
    }
}

DatagridBodyLocationAudit.propTypes = {
    columns: PropTypes.number,
    currentToggle: PropTypes.object,
    eventEmitter: PropTypes.any,
    idsList: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    resource: PropTypes.string,
    data: PropTypes.object.isRequired,
    basePath: PropTypes.string,
    options: PropTypes.object,
    rowOptions: PropTypes.object,
    styles: PropTypes.object,
    toggleEventName: PropTypes.string,
};

DatagridBodyLocationAudit.defaultProps = {
    columns: 1,
    currentToggle: {},
    data: {},
    idsList: [],
    toggleEventName: 'locationAuditToggle',
};

const PureDatagridBodyLocationAudit = shouldUpdate(
    (props, nextProps) => nextProps.isLoading === false
)(DatagridBodyLocationAudit);

// trick material-ui Table into thinking this is one of the child type it supports
PureDatagridBodyLocationAudit.muiName = 'TableBody';

export default PureDatagridBodyLocationAudit;



// WEBPACK FOOTER //
// ./src/Fuse/admin/DatagridBodyLocationAudit.js